var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"},on:{"click":_vm.wrapperClickMethods}},[_c('app-header',{attrs:{"headerTitle":_vm.headerTitle,"headerType":_vm.headerType}}),_vm._v(" "),_c('router-view'),_vm._v(" "),(_vm.isSearchShown)?_c('app-search'):_vm._e(),_vm._v(" "),_c('app-footer'),_vm._v(" "),_c('app-bg-layer'),_vm._v(" "),_c('app-light-box')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01eb81a6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 289
// module chunks = 0